import React from "react";
import { useMediaQuery } from "../hooks/useMediaQuery";

export enum ScreenSize {
  XL = "XL",
  L = "L",
  M = "M",
  S = "S",
  XS = "XS",
}

export enum ScreenHeight {
  XL = 1440,
  L = 1080,
  M = 800,
  S = 600,
  // There is no 'XS' as the screen is extra small if the
  // media query does not match any of these entries
}

const heightMediaQueryBuilder = (height: number): string => `(min-height: ${height}px)`;

/**
 * If the screen size is undefined then the console is not running in a browser
 */
export const ScreenSizeContext = React.createContext<ScreenSize | undefined>(undefined);

export const ScreenSizeContextProvider: React.FC = ({ children }): JSX.Element => {
  const [currentScreenSize, setCurrentScreenSize] = React.useState<ScreenSize>();

  const isXl = useMediaQuery(heightMediaQueryBuilder(ScreenHeight.XL));
  const isL = useMediaQuery(heightMediaQueryBuilder(ScreenHeight.L));
  const isM = useMediaQuery(heightMediaQueryBuilder(ScreenHeight.M));
  const isS = useMediaQuery(heightMediaQueryBuilder(ScreenHeight.S));

  React.useEffect(() => {
    let screenSize: ScreenSize;

    if (isXl) screenSize = ScreenSize.XL;
    else if (isL) screenSize = ScreenSize.L;
    else if (isM) screenSize = ScreenSize.M;
    else if (isS) screenSize = ScreenSize.S;
    else screenSize = ScreenSize.XS;

    setCurrentScreenSize(screenSize);
  }, [isXl, isL, isM, isS]);

  return (
    <ScreenSizeContext.Provider value={currentScreenSize}>
      {children}
    </ScreenSizeContext.Provider>
  );
};
